module.exports = __webpack_public_path__ + "img/L1_Door.c1020d24.svg";